import component from './component';
import connect from "./reduxConnect";


export default connect(component);